export default {
  serverBaseUrl: process.env.VUE_APP_BASE_URL,
  ApiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  ApiBaseUrlV2: process.env.VUE_APP_API_BASE_URL_V2,
  paymentsBaseUrl: process.env.VUE_APP_PAYMENTS_API_URL,
  paymentsBaseUrlV2: process.env.VUE_APP_PAYMENTS_API_URL_V2,
  communicationBaseUrlV1: process.env.VUE_APP_COMMUNICATION_V1_API_URL,
  communicationBaseUrl: process.env.VUE_APP_COMMUNICATION_API_URL,
  lettersBaseUrl: process.env.VUE_APP_LETTERS_API_URL,
}
